module.exports = __webpack_public_path__ + "static/media/lock.b6d7b661.svg";